import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { filterParseDateBetween } from "go-core/components/Formatters/FormatDate";
import {
	FILTER_SEPARATOR,
	FILTER_VALUE_SEPARATOR,
	NEW_WAY_TO_ENCODING_FILTER_SIGN,
} from "go-list/core/components/Filter/services";
import { selectPartner } from "../../../../../../../../../services/partner/selectors";

interface Props {
	count_of_loans_to_close: number;
	count_of_closed_loans: number;
}

const PartnerLoansCard = ({ count_of_loans_to_close, count_of_closed_loans }: Props) => {
	const { t } = useTranslation("admin");
	const partner = useSelector(selectPartner);

	const getLastWeekDate = () => {
		const now = new Date();
		const weekAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
		return filterParseDateBetween(weekAgo, now);
	};

	return (
		<Card>
			<Card.Body>
				<h5>{t("modules.partner.field.loans.title")}</h5>
				<div className={"card-body-item"}>
					<div className={"item-info"}>
						<span>
							{t("modules.partner.field.closed_loans.title")}
							<Link
								to={`/partnership/${partner?.id}/loans?f=${btoa(
									unescape(
										encodeURIComponent(
											`${NEW_WAY_TO_ENCODING_FILTER_SIGN}status|e=CLOSED${FILTER_SEPARATOR}opened_at|bt=${getLastWeekDate()}`
										)
									)
								)}`}
								target="_blank"
								rel="noreferrer"
								className="ms-1"
							>
								{count_of_closed_loans}
							</Link>
						</span>
					</div>
				</div>
				<div className={"card-body-item"}>
					<div className={"item-info"}>
						<span>
							{t("modules.partner.field.loans_to_close.title")}
							<Link
								to={`/partnership/${partner?.id}/loans?f=${btoa(
									unescape(
										encodeURIComponent(
											`${NEW_WAY_TO_ENCODING_FILTER_SIGN}status|e=OPEN${FILTER_VALUE_SEPARATOR}ACCEPTED`
										)
									)
								)}`}
								target="_blank"
								rel="noreferrer"
								className="ms-1"
							>
								{count_of_loans_to_close}
							</Link>
						</span>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PartnerLoansCard;
